import { initRouteItems } from '@bikemap/js/integrations/routes'
import { context } from '@bikemap/js/services'
import { WEB_APP_URLS } from '@bikemap/js/settings'
import { defaultGet, getApiHeaders, logError } from '@bikemap/js/utility'

const routeId = context.page('routeId')

/**
 * Inject rel="ugc,nofollow" attribute to anchor links.
 * Used for route description for SEO purposes.
 */
export function injectAnchorRel() {
    document.querySelectorAll('.js-inject-a-rel a').forEach(a => {
        a.setAttribute('rel', 'ugc,nofollow')
    })
}

/**
* Fetch and open deep links on click (e.g. https://bikemap.page.link/abcd).
* Link shouldn't be in the DOM to prevent search engines to crawl it. For SEO purposes.
*/
export function injectDeepLinks() {
    document.querySelectorAll('.js-inject-deep-link').forEach((el) => {
        el.addEventListener('click', async (e) => {
            e.preventDefault()
            try {
                const apiPath = el.getAttribute('data-api-deep-link-path')
                const fallbackUrl = encodeURIComponent(WEB_APP_URLS.WEB_APP_ROUTE_DETAILS_URL.replace(':id', routeId))
                const res = await defaultGet(apiPath + '&ofl=' + fallbackUrl, getApiHeaders())
                if (res && res.deep_link) {
                    window.location.href = res.deep_link
                }
            } catch (error) {
                logError('Fetch deep link', error, { el, e })
            }
        })
    })
}

/**
* Fetch, display and initialize the related routes lists. They are not lazy-loaded to make sure
* links get crawled.
*/
export function initRelatedSection() {
    const {
        similarRoutesUrl,
        popularRoutesNearbyUrl,
        notableRoutesUrl,
    } = context.page()

    loadRelatedRoutesList('suggested-routes', similarRoutesUrl)
    loadRelatedRoutesList('popular-routes', popularRoutesNearbyUrl)
    loadRelatedRoutesList('notable-routes', notableRoutesUrl)
}

/**
 * Fetch a rendered list and insert it into a container.
 * @param {string} containerId ID of a container for the list
 * @param {string} url URL to fetch from
 */
async function loadRelatedList(containerId, url) {
    const container = document.getElementById(containerId)

    const { count, html } = await defaultGet(url, {
        'Cache-Control': 'no-cache',
        'Ignore-It': 'True',
    })

    if (count) {
        container.innerHTML = html
    } else {
        container.querySelectorAll(':not(.nothing-related)').forEach(el => el.remove())
        const message = container.querySelector('.nothing-related')
        message && message.classList.remove('hidden')
    }
}

/**
* Fetch a rendered routes list, insert it into a container and initialize.
* @param {string} containerId ID of a container for the list
* @param {string} url URL to fetch from
*/
async function loadRelatedRoutesList(containerId, url) {
    await loadRelatedList(containerId, url)
    initRouteItems(document.querySelector('#' + containerId + ' .routes-list'))
}
